import { render, staticRenderFns } from "./ShowAttachment.vue?vue&type=template&id=18227e22&"
import script from "./ShowAttachment.vue?vue&type=script&lang=js&"
export * from "./ShowAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports